import React from 'react'

export default function FooterMobile() {
    return (
        <div className='bg-gradient-to-l from-gray-900 to-gray-800 from text-white py-4 flex flex-row justify-center px-4 font-montserrat'>
            <p className='text-[13px]' >&copy; Copyright 2016 All rights reserved</p>
        </div>
    )
}
